<script module>
  import { resolve } from '$app/paths'

  export const meta = {
    title: 'Create an organization',
    teaser:
      'Learn how to create an organization on Pausly after setting up your personal\naccount. Find steps to navigate and set up your organization, noting the\ndifference in capabilities between plans.',
    sort: 0,
  }
</script>

<p>
  After setting up your personal account on Pausly, you're all set to create an
  organization.
</p>
<p>
  Simply navigate to the
  <a href={resolve('/settings/organizations')}
    >organization section in your settings</a
  > and hit the "New organization" button. Then, just follow the on-screen instructions
  to get your organization up and running.
</p>
<p>
  Once your organization is created, you'll be directed to its dedicated page.
  Here, you can dive into additional settings adjustments and begin the process
  of welcoming your team members.
</p>
<p>
  Please note: Organizations can be created with the free plan, however, their
  capabilities will be somewhat restricted.
</p>
